import { h, render, Component } from 'preact';
import { Wizard } from '../wizard';

export class InfoVerifyLandline extends Component {

  constructor(props) {
    super(props);

    this.state = {
      submitted: false
    }

  }

  submitPhone = e => {
    this.setState({submitted:true})
    var me = this;

    fetch(
      "/api/v1/enroll/phone",
      {
        method:"POST",
        body:JSON.stringify({
          "number": me.props.phoneNumber, 
          "extension": me.props.extension,
          "type": "landline",
          "platform": "unknown"}),
        headers:{"Content-Type":"application/json"}
      }
    ).then( resp => {
      if(resp.ok) {
        me.props.next();
      } else {
        this.setState({submitted:false})
      }
    });
  }

  render(props, state) {
		return (
      <Wizard isPanel="true" 
        title={"Verify ownership of "+props.formattedPhoneNumber+(props.extension?' x'+props.extension:'')}
        prev={{callback: props.prev}}
        next={{callback: this.submitPhone, disabled:state.submitted}}>
        <p>
        Please double check the number shown above for accuracy before clicking "Continue". On the next screen you will see a button for initiating a phone call. Once pressed, you will need to answer the phone and follow its instructions to complete the process.
        </p>
      </Wizard>
		)
  }
}
